import axios from 'axios'

// a star shows its new colour at once and the request follows; if the server refuses, the list goes back the way it was
export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  // the api only ever returns the logged in user's own favorites
  list (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/usersystemfavorite')
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  // a star set or cleared in another tab: the created message carries the record and the destroyed one its id,
  // so neither needs the list re-read
  created (context, opts) {
    if (opts && opts.id) {
      context.commit('LIST_ADD', opts)
    } else {
      context.dispatch('list').catch(() => {})
    }
  },
  updated (context, opts) {
    context.dispatch('list').catch(() => {})
  },
  destroyed (context, opts) {
    context.commit('LIST_REMOVE', opts)
  },
  // ===========================List Edits===============================
  // opts: { system }
  add (context, opts) {
    // a stand-in row lights the star now; the server's record replaces it when the answer comes
    const placeholder = { id: `pending-${opts.system}`, system: opts.system, pending: true }
    context.commit('LIST_ADD', placeholder)
    return new Promise((resolve, reject) => {
      axios
        .post('/api/usersystemfavorite', opts)
        .then(({ data }) => {
          context.commit('LIST_REMOVE', placeholder.id)
          context.commit('LIST_ADD', data)
          resolve(data)
        }).catch((error) => {
          context.commit('LIST_REMOVE', placeholder.id)
          // already starred (e.g. from another tab): the server sends the existing record, which is what we wanted
          if (error.response && error.response.status === 409 && error.response.data && error.response.data.id) {
            context.commit('LIST_ADD', error.response.data)
            resolve(error.response.data)
          } else {
            reject(error)
          }
        })
    })
  },
  // opts: the favorite's id
  delete (context, opts) {
    // the row goes now and comes back only if the server refuses
    const removed = context.state.list.find((favorite) => favorite.id === opts)
    context.commit('LIST_REMOVE', opts)
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/usersystemfavorite/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          if (removed) {
            context.commit('LIST_ADD', removed)
          }
          reject(error)
        })
    })
  }
}
